export const IMAGE_WIDTH = 1920;
export const MOBILE_MAX_WIDTH = 800;

export const safeParsePos = (raw) => {
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.x !== "number" || typeof parsed.y !== "number") return null;
    return parsed;
  } catch (e) {
    return null;
  }
};

export const readStoredPos = (storageKey) => {
  if (!storageKey) return null;

  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return null;
    return safeParsePos(raw);
  } catch (e) {
    return null;
  }
};

export const writeStoredPos = (storageKey, pos) => {
  if (!storageKey) return;

  try {
    window.localStorage.setItem(storageKey, JSON.stringify(pos));
  } catch (e) {
    // ignore storage failures
  }
};

export const readStoredExpanded = (storageKey, defaultExpanded) => {
  if (!storageKey) return defaultExpanded;

  try {
    const raw = window.localStorage.getItem(`${storageKey}.expanded`);
    if (raw === null || raw === undefined) return defaultExpanded;
    return raw === "1";
  } catch (e) {
    return defaultExpanded;
  }
};

export const writeStoredExpanded = (storageKey, expanded) => {
  if (!storageKey) return;

  try {
    window.localStorage.setItem(`${storageKey}.expanded`, expanded ? "1" : "0");
  } catch (e) {
    // ignore
  }
};

export const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const clampToViewport = (pos, viewportW, viewportH, cardW, cardH, scale, padding) => {
  const normalizedScale = scale && scale > 0 ? scale : 1;

  const normalizedPadding = typeof padding === "number"
    ? {
      left: padding,
      right: padding,
      top: padding,
      bottom: padding,
    }
    : (padding || {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    });

  const maxX = Math.max(0, (viewportW - normalizedPadding.right) / normalizedScale - cardW);
  const maxY = Math.max(0, (viewportH - normalizedPadding.bottom) / normalizedScale - cardH);
  const minX = (normalizedPadding.left || 0) / normalizedScale;
  const minY = (normalizedPadding.top || 0) / normalizedScale;

  return {
    x: clamp(pos.x, minX, maxX),
    y: clamp(pos.y, minY, maxY),
  };
};

export const getIsMobile = () => {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;
};